import React from "react";
import { XIcon } from "@heroicons/react/solid";
import { BallTriangle } from "react-loading-icons";
import useState from "react-usestateref";
import Prism from "prismjs";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism.css"; //Example style, you can use another
import axios from "axios";
import { HashLoader } from "react-spinners";
import backendService from "../services.js/backendService";


function CodeSnippetModal({ openCodeRunModal, codeData }) {

  const [output, setOutput, outputRef] = useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [stdin, setStdin] = React.useState("");
  const runCode = async () => {
    try {
      setIsLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/compilecode`,
        {
          script: codeData.script,
          language: codeData.language,
          stdin: stdin,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      setIsLoading(false);
      setOutput(res.data.compiled);
      
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      setOutput(err);
    }
  };
  React.useEffect(() => {
    runCode();
  }, []);

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto chat__container fixed inset-0 z-50 outline-none focus:outline-none ">
        <div className="w-11/12 sm:w-3/4 md:w-2/3 lg:w-1/2 relative my-6 shadow-md shadow-black mx-auto max-w-2xl rounded-md">
          {/*content*/}
          <div className="border-0 rounded-lg  relative flex flex-col w-full  outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5  rounded-t bg-background">
              <h3 className="text-xl text-primary font-robo ">Output</h3>
              <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                <XIcon
                  className="h-5 w-5 "
                  aria-hidden="true"
                  onClick={() => openCodeRunModal(false)}
                />
              </div>
            </div>
            {/*body*/}
            <div className="max-h-[70vh] overflow-y-auto relative px-6 flex-auto bg-background">
              {isLoading ? (
                <div className="flex h-full justify-center items-center">
                  {/* <BallTriangle color="#fff" size={50} /> */}
                  <HashLoader color="#0077b6" loading={isLoading} />
                  <p className="text-center text-xl font-robo text-secondary  px-4">
                    Executing please wait...
                  </p>
                </div>
              ) : (
                <div className="h-full  flex flex-col justify-end items-center">
                  <textarea
                    className={`${
                      outputRef.current?.output
                        ? "text-primary rounded-lg bg-palette_color2 w-full h-full resize-none overflow-auto font-robo  px-4 py-2 border-[1px] border-palette_color1 "
                        : "text-red rounded-lg bg-palette_color2 w-full h-full resize-none overflow-auto font-robo  px-4 py-2 border-[1px] border-palette_color1"
                    }`}
                    value={
                      outputRef.current?.output
                        ? outputRef.current.output
                        : outputRef.current
                    }
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    id="terminal"
                    readOnly
                    row={13}
                  />
                  {outputRef.current?.cpuTime && (
                    <p className="text-center text-lg font-robo text-secondary  mt-2">
                      Execution Time: {outputRef.current.cpuTime} seconds
                    </p>
                  )}
                  <div className="w-full justify-start items-center mt-2">
                    <div className="flex items-center justify-start">
                  <h3 className="text-xl text-primary font-robo ">Input</h3>
                  <h3 className="text-sm text-primary font-robo ml-2 italic">(Enter each input in each line)</h3>
                  </div>
                  <div className="flex w-full justify-center items-center mt-2">
                    <textarea
                      className="text-primary  bg-palette_color2 w-full h-full resize-none overflow-auto font-robo  px-4 py-2 border-[1px] border-palette_color1 chat__container"
                      value={stdin}
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      id="terminal"
                      row={6}
                      onChange={(e) => setStdin(e.target.value)}
                    />
                  </div>
                    </div>
                 
                </div>
              )}
              

            </div>
            {/*footer*/}
            <div className="flex items-center justify-end p-3 pt-3 pr-6  rounded-b bg-palette_color2">
              <button
                className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                type="button"
                onClick={async () => {
                  await runCode();
                }}
              >
                Run Code Again
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-50  fixed inset-0 z-20 bg-black"></div>
    </>
  );
}

export default CodeSnippetModal;
